import React, { useState } from 'react';
import {
  Grid,
  Box,
  Button,
  Typography,
  IconButton,
  Tooltip,
  Checkbox,
} from '@mui/material';
import RecentActivityCard from '../components/RecentActivityCard';

// import ClearIcon from '@mui/icons-material/Clear';
// import SelectAllIcon from '@mui/icons-material/SelectAll';
import {
  CheckedScreenIcon,
  CheckScreenIcon,
  DeleteBlackIcon,
  ForwordBlackIcon,
  ImageBlackIcon,
} from '../icons';
import ActionModals from './ActionModals';

const fallbackIdleCard = [
  {
    timeRange: '',
    duration: '',
    user: '',
    task: '',
    image: '',
    progress: { total: 0, cursor: 0, keyboard: 0 },
  },
];

const RecentActivityScreenshots = ({
  data = [],
  columns = 3,
  showProgress = false,
  showIndexCircle = false,
  showSummary = false,
}) => {
  const dataToRender = data.length > 0 ? data : fallbackIdleCard;
  const [selectMode, setSelectMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [activeModal, setActiveModal] = useState(null); // forward | image | delete | null

  const handleSelectChange = (index, checked) => {
    if (checked && !selectMode) setSelectMode(true);

    setSelectedItems((prev) =>
      checked ? [...prev, index] : prev.filter((i) => i !== index)
    );

    if (!checked && selectedItems.length === 1) {
      setSelectMode(false);
    }
  };

  const handleSelectAll = () => {
    if (selectedItems.length === dataToRender.length) {
      setSelectedItems([]);
      setSelectMode(false);
    } else {
      setSelectedItems(dataToRender.map((_, index) => index));
      setSelectMode(true);
    }
  };

  const handleDeleteSelected = () => {
    setSelectedItems([]);
    setSelectMode(false);
  };
  const handleMoveSelected = () => {
    setSelectedItems([]);
    setSelectMode(false);
  };
  const handleImageSelected = () => {
    setSelectedItems([]);
    setSelectMode(false);
  };

  // const handleClearSelection = () => {
  //   setSelectedItems([]);
  //   setSelectMode(false);
  // };

  const handleCancel = () => {
    setSelectedItems([]);
    setSelectMode(false);
  };

  const closeModal = () => setActiveModal(null);



  return (
    <>
      <Box p={0}>
        {/* Selection Controls */}
        {selectMode && !activeModal && (
          <Box
            sx={{
              position: 'fixed',
              top: '20px',
              zIndex: '99',
              transform: 'translateX(-50%)',
              left: { xl: '50%', lg: '50%', md: '44%', sm: '50%', xs: '50%' },
              marginLeft: { xl: '40px', lg: '40px', md: '4px', sm: '4px' },
              width: { xl: 'auto', lg: 'auto', md: '60%', sm: '86%', xs: '95%' },
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
              boxShadow: '0px 4px 35.7px 0px rgba(0, 0, 0, 0.25)',
              p: '10px 20px',
              backgroundColor: '#fff',
              borderRadius: 3,
              transition: 'background-color 0.3s ease',
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Typography
                sx={{ fontSize: '16px', color: '#1A1F36' }}
              >
                <span style={{ color: '#0076FE' }}>
                  {selectedItems.length}
                </span>{' '}
                screens selected
              </Typography>

              <Tooltip title="move">
                <IconButton
                  size="small"
                  onClick={() => setActiveModal('move')}
                  disabled={selectedItems.length === 0}
                  sx={{ '&:hover': { background: 'none' } }}
                >
                  <ForwordBlackIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Image">
                <IconButton
                  size="small"
                  onClick={() => setActiveModal('image')}
                  disabled={selectedItems.length === 0}
                  sx={{ '&:hover': { background: 'none' } }}
                >
                  <ImageBlackIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete Selected">
                <IconButton
                  size="small"
                  onClick={() => setActiveModal('delete')}
                  disabled={selectedItems.length === 0}
                  color="error"
                  sx={{ '&:hover': { background: 'none' } }}
                >
                  <DeleteBlackIcon />
                </IconButton>
              </Tooltip>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Tooltip title="Select All">
                <IconButton
                  onClick={handleSelectAll}
                  sx={{
                    fontSize: '16px',
                    borderRadius: '0',
                    background: 'none',
                    '&:hover': { background: 'none' },
                  }}
                  color={
                    selectedItems.length === dataToRender.length
                      ? 'primary'
                      : 'default'
                  }
                >
                  Select All
                </IconButton>
              </Tooltip>
              <Button
                size="small"
                onClick={handleCancel}
                sx={{
                  fontSize: '16px',
                  background: '#D9D9D9',
                  color: '#373737',
                  textTransform: 'capitalize',
                  padding: '6px 20px',
                  borderRadius: '4px',
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        )}
        {showSummary && (
          <Box display="flex" alignItems="center" gap={2} className="showSummaryCs" sx={{ padding: '24px 0 12px 0', }}>
            <Box
              component="li"

              sx={{ listStyle: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            >
              <Checkbox
                onClick={handleSelectAll}
                checked={selectedItems.length === dataToRender.length && dataToRender.length > 0}
                icon={<CheckScreenIcon />}
                checkedIcon={<CheckedScreenIcon />}
                sx={{
                  padding: 0,
                  background: '#d3d3d3',
                  borderRadius: '50px',
                  border: '1px solid #fff',
                  boxShadow: '0 1px 1px rgba(0, 0, 0, 0.3)',
                  '& .MuiSvgIcon-root': {
                    fontSize: 25,
                  },
                }}
              />

            </Box>

            <Box component="li" sx={{ listStyle: 'none' }}>
              <Typography variant="body2">
                <Box component="span" fontWeight="500" sx={{ fontSize: '12px', background: '#004DFF', borderRadius: '50px', color: '#fff', padding: '2px 16px' }}>11:00 am - 12:00 pm</Box>
              </Typography>
            </Box>

            <Box component="li" sx={{ listStyle: 'none' }}>
              <Typography variant="body2" sx={{ color: '#9095A1', fontSize: '14px', }}>
                Total time worked: <Box component="span" fontWeight="bold" sx={{ color: '#373737', }}>0:27:36</Box>
              </Typography>
            </Box>

            <Box component="li" sx={{ listStyle: 'none' }}>
              <Typography variant="body2" sx={{ color: '#9095A1', fontSize: '14px', }}>
                Activity: <Box component="span" fontWeight="bold" sx={{ color: '#D36A08', }}>20%</Box>
              </Typography>
            </Box>
          </Box>
        )}
        {/* Cards Grid */}
        <Grid
          container
          spacing={2}
          sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: 2,
          }}
        >
          {dataToRender.map((data, index) => {
            const safeData = {
              ...data,
              progress: data.progress || { total: 0, cursor: 0, keyboard: 0 },
            };

            return (
              <Grid item key={index}>
                <RecentActivityCard
                  {...safeData}
                  index={index}
                  allImages={dataToRender.map((d) => d.image)}
                  showProgress={showProgress}
                  showIndexCircle={showIndexCircle}
                  isSelected={selectedItems.includes(index)}
                  selectMode={selectMode}
                  onSelect={() =>
                    handleSelectChange(index, !selectedItems.includes(index))
                  }
                  onRequestDeleteModal={() => setActiveModal('delete')}
                  onRequestMoveModal={() => setActiveModal('move')}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>

      {/* Modals */}
      <ActionModals
        activeModal={activeModal}
        closeModal={closeModal}
        handleDeleteSelected={handleDeleteSelected}
        handleMoveSelected={handleMoveSelected}
        handleImageSelected={handleImageSelected}
      />
    </>
  );
};

export default RecentActivityScreenshots;
